import axios from "axios";
import { useEffect, useState } from "react";

export const flicker =  axios.create({
    baseURL: "https://api.flickr.com/services/rest/?method=flickr.photos.search&api_key=636e1481b4f3c446d26b8eb6ebfe7127&per_page=24&format=json&nojsoncallback=1",
    // method: "get"
});

// const controller = new AbortController();

export const useGetPhotoByTagsQuery = tags => {
    const [data, setData] = useState(null);
    const [isFetching, setIsFetching] = useState(true);
    const [error, setError] =  useState(null);
    
    // const { signal } = controller;

    useEffect(() => {
        const fetchPhotos = async () => {
            try {
                // if(!signal.aborted) controller.abort();
                setIsFetching(true);
                const { data: {photos: { photo: resultPhotos }} } = await flicker.get(`&tags=${tags}`);
                setData(resultPhotos);
                setIsFetching(false);
            } catch(err){
                setIsFetching(false);
                setError(err.message);
            }
        }

        fetchPhotos();
    }, [tags])
    
    return [data, isFetching, error];
}